export const ACCCATEGORY_LOADING = "ACCCATEGORY_LOADING";
export const ACCCATEGORY_RESET = "ACCCATEGORY_RESET";
export const GET_ACCCATEGORY = "GET_ACCCATEGORY";
export const GET_ACCCATEGORY_SUCCESS = "GET_ACCCATEGORY_SUCCESS";
export const GET_ACCCATEGORY_FAIL = "GET_ACCCATEGORY_FAIL";
export const DELETE_ACCCATEGORY = "DELETE_ACCCATEGORY"
export const DELETE_ACCCATEGORY_SUCCESS = "DELETE_ACCCATEGORY_SUCCESS"
export const DELETE_ACCCATEGORY_FAIL = "DELETE_ACCCATEGORY_FAIL"
export const UPDATE_ACCCATEGORY = "UPDATE_ACCCATEGORY"
export const UPDATE_ACCCATEGORY_SUCCESS = "UPDATE_ACCCATEGORY_SUCCESS"
export const UPDATE_ACCCATEGORY_FAIL = "UPDATE_ACCCATEGORY_FAIL"
export const ADD_NEW_ACCCATEGORY = "ADD_NEW_ACCCATEGORY"
export const ADD_ACCCATEGORY_SUCCESS = "ADD_ACCCATEGORY_SUCCESS"
export const ADD_ACCCATEGORY_FAIL = "ADD_ACCCATEGORY_FAIL"